import { render } from "./Opportunity.vue?vue&type=template&id=4971c196"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
script.render = render

export default script